<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>
      <h1>Accountants voor bedrijven &amp; ZZP'ers</h1>
      <p>
        <strong
          >De meeste ondernemers en ZZP’ers kunnen hun tijd veel nuttiger
          besteden dan aan de boekhouding, jaarrekening of belastingaangifte.
          Maar als ondernemer bent u&nbsp;</strong
        ><strong
          >verplicht deze administratie minimaal 7 jaar bij te houden. En die
          moet ook nog eens voldoen aan de wettelijke eisen.&nbsp;</strong
        ><strong
          >Accountants kunnen u deze vervelende taken uit handen nemen. Dit doen
          ze efficiënt, maar ook persoonlijk.</strong
        >
      </p>

      <h2>Bedrijven</h2>
      <p>
        Uit statistieken blijkt dat ondernemers met een goed bijgewerkte
        administratie minder risico lopen om failliet te gaan. Een goede reden
        dus om uw administratieve zaken op orde te hebben. Maar wat kunnen
        accountants voor u betekenen en wat is hun werkwijze? De administratie
        die accountants verrichten voor ondernemers zijn onder andere:
      </p>
      <ul>
        <li>De complete financiële administratie</li>
        <li>Het opstellen van jaarrekeningen en tussentijdse cijfers</li>
        <li>De salarisadministratie</li>
        <li>Verzorgen van aangiftes&nbsp;</li>
      </ul>
      <p>
        Periodiek verstrekt u gegevens als inkoop- en verkoopfacturen,
        bankafschriften en brandstofbonnen aan uw financieel adviseur. Deze
        worden door uw accountant verwerkt in hun boekhoudsysteem. Na verwerking
        ontvangt u periodiek een actuele balans en winst- en verliesrekening. U
        bent hierdoor verzekerd van een helder inzicht in de financiële status
        van uw onderneming.&nbsp;
      </p>

      <h2>ZZP’ers</h2>
      <p>
        Door het ontbreken van de nodige kennis en tijd, benutten ZZP’ers hun
        aftrekposten niet optimaal. Hierdoor lopen ze veel besparingen mis en
        zien ze de administratie vaak als iets lastigs. Ook voor deze groep is
        het aan te raden een accountant in te schakelen. Hiermee is de ZZP'er
        verzekerd van een correcte administratie en kan optimaal gebruik worden
        gemaakt van de fiscale voordelen bij de belastingaangifte. De taken die
        worden verricht zijn onder andere:
      </p>
      <ul>
        <li>Uitvoeren administratie per kwartaal</li>
        <li>Winst- en verliesrekening per jaar</li>
        <li>Aangifte inkomstenbelasting (incl. partner)</li>
        <li>3 maandelijkse btw-aangifte.</li>
      </ul>
      <p>
        Wilt u graag meer weten over de fiscale voordelen voor u als ondernemer
        of ZZP’er? Neem dan eens contact op met accountants in uw postcodegebied
        via Accountantvergelijker.nl. Zij geven u graag persoonlijk advies!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks.vue'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Op zoek naar een accountant?',
      description:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van vakkundige Bedrijven uit jouw regio ✓ Dé beste prijs voor jouw Reparatie ✓ Bespaar tot 40%',
    }
  },
}
</script>
